/* Lantana Ritual: native rails and anchor navigation. Never intercept form POST. */
(function () {
  "use strict";
  if (window.LantanaRitual) window.LantanaRitual.destroy();
  var lifecycle = new AbortController();
  var active, observers = [], disposers = [], frame = 0, timer;
  function cleanup() {
    if (active) active.abort();
    disposers.forEach(function (dispose) { dispose(); });
    disposers = [];
    observers.forEach(function (observer) { observer.disconnect(); });
    observers = [];
    cancelAnimationFrame(frame);
    frame = 0;
  }
  function initialize() {
    cleanup();
    active = new AbortController();
    var signal = active.signal;
    function on(target, name, fn, options) {
      target.addEventListener(name, fn, Object.assign({ signal: signal }, options));
    }
    function observe(element, fn) {
      if ("ResizeObserver" in window) {
        var observer = new ResizeObserver(fn);
        observer.observe(element);
        observers.push(observer);
      } else on(window, "resize", fn, { passive: true });
    }
    function behavior() {
      return matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
    }
    document.querySelectorAll(".r21-header").forEach(function (header) {
      var toggle = header.querySelector("[data-mobile-menu-toggle]");
      var label = toggle && toggle.querySelector("[data-mobile-menu-label]");
      var nav = toggle && document.getElementById(toggle.getAttribute("aria-controls"));
      if (!toggle || !label || !nav) return;
      var mobile = matchMedia("(max-width: 1050px)");
      var open = false, lastFocused = document.activeElement, pending = [];
      function later(fn) { pending.push(setTimeout(function () { if (!signal.aborted) fn(); }, 0)); }
      function setOpen(value, returnFocus) {
        open = Boolean(value && mobile.matches);
        header.toggleAttribute("data-mobile-menu-open", open);
        toggle.setAttribute("aria-expanded", String(open));
        label.textContent = toggle.getAttribute(open ? "data-menu-close-label" : "data-menu-open-label");
        if (returnFocus && mobile.matches) toggle.focus({ preventScroll: true });
      }
      on(document, "focusin", function (event) { lastFocused = event.target; });
      on(toggle, "click", function () { setOpen(!open); });
      on(document, "ritual:before-modal-open", function () { setOpen(false); });
      on(document, "keydown", function (event) {
        if (event.key !== "Escape" || !open) return;
        event.preventDefault(); setOpen(false, true);
      });
      on(document, "pointerdown", function (event) {
        if (open && !header.contains(event.target)) setOpen(false, nav.contains(document.activeElement));
      });
      on(header, "focusout", function (event) {
        if (event.relatedTarget) {
          if (open && !header.contains(event.relatedTarget)) setOpen(false);
          return;
        }
        later(function () { if (open && !header.contains(document.activeElement)) setOpen(false); });
      });
      on(nav, "click", function (event) {
        var link = event.target.closest("a[href]");
        if (!open || !link || event.defaultPrevented || event.button > 0 ||
            event.metaKey || event.ctrlKey || event.altKey || event.shiftKey ||
            link.hasAttribute("download") || (link.target && link.target !== "_self")) return;
        setOpen(false, true);
        var href = link.getAttribute("href"), destination;
        if (!href.startsWith("#")) return;
        try { destination = document.getElementById(decodeURIComponent(href.slice(1))); }
        catch (_) { return; }
        if (!destination) return;
        var heading = destination.querySelector("h1,h2,h3") || destination;
        later(function () {
          var temporary = !heading.hasAttribute("tabindex");
          if (temporary) heading.setAttribute("tabindex", "-1");
          heading.focus({ preventScroll: true });
          if (temporary) {
            on(heading, "blur", function () { heading.removeAttribute("tabindex"); }, { once: true });
            disposers.push(function () { heading.removeAttribute("tabindex"); });
          }
        });
      });
      on(mobile, "change", function () {
        var focused = document.activeElement;
        setOpen(false);
        if (mobile.matches && (nav.contains(focused) || (focused === document.body && nav.contains(lastFocused))))
          toggle.focus({ preventScroll: true });
        if (!mobile.matches && focused === toggle)
          (nav.querySelector("a[href]") || header.querySelector(".r21-wordmark")).focus({ preventScroll: true });
      });
      on(document, "shopify:block:select", function (event) { if (nav.contains(event.target)) setOpen(true); });
      toggle.hidden = false;
      header.setAttribute("data-mobile-menu-ready", "");
      setOpen(false);
      disposers.push(function () {
        pending.forEach(clearTimeout);
        setOpen(false);
        header.removeAttribute("data-mobile-menu-ready");
        toggle.hidden = true;
      });
    });
    var forms = Array.from(document.querySelectorAll(".r21-form"));
    var primary = document.querySelector(".r21-form--primary");
    var invitations = Array.from(document.querySelectorAll("[data-floating-access]"));
    function updateAccess() {
      frame = 0;
      var visible = forms.some(function (form) {
        var rect = form.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < innerHeight;
      });
      var focused = forms.some(function (form) { return form.contains(document.activeElement); });
      invitations.forEach(function (invitation) {
        invitation.hidden = !primary || primary.getBoundingClientRect().bottom > 0 || visible || focused;
      });
    }
    function queueAccess() { if (!frame) frame = requestAnimationFrame(updateAccess); }
    on(window, "scroll", queueAccess, { passive: true });
    on(window, "resize", queueAccess, { passive: true });
    on(document, "focusin", queueAccess);
    on(document, "focusout", queueAccess);
    observe(document.body, queueAccess);
    invitations.forEach(function (invitation) {
      on(invitation, "click", function (event) {
        var href = invitation.getAttribute("href");
        if (!href || href.charAt(0) !== "#") return;
        var target = document.getElementById(href.slice(1));
        var email = target && target.querySelector('input[type="email"]');
        if (!email) return;
        event.preventDefault(); // Anchor only; native customer forms are untouched.
        history.replaceState(null, "", href);
        email.focus({ preventScroll: true });
        email.scrollIntoView({ block: "center", behavior: behavior() });
        updateAccess();
      });
    });
    forms.forEach(function (form) {
      var input = form.querySelector('input[type="email"]');
      var field = form.querySelector(".r21-form__field");
      if (!input || !field) return;
      on(input, "invalid", function () {
        field.setAttribute("data-invalid", "true");
        input.setAttribute("aria-invalid", "true");
      });
      on(input, "input", function () {
        field.removeAttribute("data-invalid");
        input.removeAttribute("aria-invalid");
      });
    });
    document.querySelectorAll("[data-horizontal-rail]").forEach(function (rail) {
      var helpId = rail.getAttribute("data-rail-help");
      var controls = document.getElementById(rail.getAttribute("data-rail-controls"));
      var previous = controls && controls.querySelector("[data-rail-prev]");
      var next = controls && controls.querySelector("[data-rail-next]");
      function updateRail() {
        var max = rail.scrollWidth - rail.clientWidth;
        var scrollable = max > 1;
        if (scrollable) {
          rail.setAttribute("tabindex", "0");
          if (helpId) rail.setAttribute("aria-describedby", helpId);
        } else {
          rail.removeAttribute("tabindex");
          rail.removeAttribute("aria-describedby");
        }
        if (controls) controls.hidden = !scrollable;
        if (previous) previous.disabled = !scrollable || rail.scrollLeft <= 1;
        if (next) next.disabled = !scrollable || rail.scrollLeft >= max - 1;
      }
      function move(direction) {
        var first = rail.firstElementChild;
        if (!first) return;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        rail.scrollBy({ left: direction * (first.getBoundingClientRect().width + gap), behavior: behavior() });
      }
      if (previous) on(previous, "click", function () { move(-1); });
      if (next) on(next, "click", function () { move(1); });
      on(rail, "scroll", updateRail, { passive: true });
      observe(rail, updateRail);
      updateRail();
    });
    document.querySelectorAll("[data-password-errors]").forEach(function (error) {
      var details = error.closest("details");
      if (details) details.open = true;
    });
    updateAccess();
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(initialize, 0); }
  ["shopify:section:load", "shopify:section:unload", "shopify:section:reorder"].forEach(function (name) {
    document.addEventListener(name, schedule, { signal: lifecycle.signal });
  });
  document.addEventListener("shopify:block:select", function (event) {
    if (event.target && event.target.closest("[data-horizontal-rail]"))
      event.target.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "auto" });
  }, { signal: lifecycle.signal });
  window.LantanaRitual = { destroy: function () {
    clearTimeout(timer); cleanup(); lifecycle.abort();
  } };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialize, { once: true, signal: lifecycle.signal });
  else initialize();
}());
